import { isDevMode } from '@angular/core';
import { LogLevel } from '@sideline/sideline-apps-shared';
import { Google, Versions } from '../constants';
import { URLs } from './urls.data';

export const app = {
  captchaKey: Google.RECAPTCHA,
  clientId: 'sideline-apps-administration',
  clientRealm: 'sideline',
  config: {
    maintenanceMode: false,
    timeOutMinutes: 30,
    // timeOutShowSeconds: 119,
    // storageSymbol: 'SidelineAppsAdmin',
    // useBrowserStorage: true,
    logging: {
      browserStorage: false,
      console: true,
      external: false,
      // level: isDevMode() ? LogLevel.All : LogLevel.Warn,
      level: LogLevel.Debug,
    },
  },
  mapsApiKey: Google.MAPS,
  marketing: {
    site: 'https://sideline-apps.com',
    names: {
      app: 'Admin',
      brand: 'Sideline',
      product: 'Sideline Apps',
    },
    slogan: 'Productivity on your side.',
  },
  routes: {
    defaultPrivate: 'dashboard',
    defaultPublic: '',
    root: '',
  },
  urls: isDevMode() ? URLs.dev : URLs.prod,
  version: Versions.APP,
};
